import { Link } from 'react-router-dom';

export default function FeaturesGrid() {
  const features = [
    {
      title: 'Local Regulations',
      description: 'Navigate El Paso business permits, licenses, and compliance requirements with ease.',
      icon: 'ri-file-list-3-line',
      bg: 'bg-[#E8F5E9]',
      link: '/regulations',
    },
    {
      title: 'Networking Events',
      description: 'Connect with fellow entrepreneurs and business leaders in the El Paso community.',
      icon: 'ri-team-line',
      bg: 'bg-[#FFE8D6]',
      link: '/networking',
    },
    {
      title: 'Market Demographics',
      description: 'Access detailed El Paso market data and demographic insights for your business.',
      icon: 'ri-bar-chart-box-line',
      bg: 'bg-[#F3E5F5]',
      link: '/demographics',
    },
    {
      title: 'Step-by-Step Guides',
      description: 'Follow comprehensive guides to launch your El Paso business successfully.',
      icon: 'ri-map-pin-line',
      bg: 'bg-[#E3F2FD]',
      link: '/guides',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            Everything You Need to Start
          </h2>
          <div className="w-24 h-1 bg-[#D2691E] mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <Link
              key={index}
              to={feature.link}
              className="group cursor-pointer"
            >
              <div className="h-full rounded-3xl overflow-hidden transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl">
                <div className={`${feature.bg} h-64 flex items-center justify-center`}>
                  <div className="w-20 h-20 flex items-center justify-center">
                    <i className={`${feature.icon} text-6xl text-gray-700`}></i>
                  </div>
                </div>
                <div className="bg-white p-6 rounded-b-3xl">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{feature.description}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}